<template>
  <div class="border">
    <div class="header capitalize-all">{{ title }}</div>
    <div class="data-container">
      <div v-for="(d, index) in data" class="row-data row" :key="index">
        <div class="date-container row">
          <div class="horizontal-line"></div>
          <b-icon-circle-fill class="icon-white"></b-icon-circle-fill>
          <b-icon-circle-fill class="icon"></b-icon-circle-fill>
          <div class="col">
            <div class="date">{{ d.date }}</div>
            <div class="hour">
              {{ d.hour }}
            </div>
          </div>
        </div>
        <div class="data-body col">
          <div class="data-header">
            {{ d.label }}
          </div>
          <div class="data-body">
            <div v-for="row in d.rows" :key="row">{{ row }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Conteos extends Vue {
  @Prop({ required: false, default: "CONTEOS CON DIFERENCIAS" })
  title!: string;

  @Prop({
    required: false,
    default: () => [
      {
        label: "Delegación: Bahía Blanca",
        date: "01/06/20",
        hour: "08:35:00",
        rows: ["Declarado: € 100.000,00", "Diferencia: € 470,00"],
      },
      {
        label: "Delegación: Bahía Blanca",
        date: "01/06/20",
        hour: "08:35:00",
        rows: ["Declarado: € 100.000,00", "Diferencia: € 470,00"],
      },
      {
        label: "Delegación: Bahía Blanca",
        date: "01/06/20",
        hour: "08:35:00",
        rows: ["Declarado: € 100.000,00", "Diferencia: € 470,00"],
      },
      {
        label: "Delegación: Bahía Blanca",
        date: "01/06/20",
        hour: "08:35:00",
        rows: ["Declarado: € 100.000,00", "Diferencia: € 470,00"],
      },
      {
        label: "Delegación: Bahía Blanca",
        date: "01/06/20",
        hour: "08:35:00",
        rows: ["Declarado: € 100.000,00", "Diferencia: € 470,00"],
      },
      {
        label: "Delegación: Bahía Blanca",
        date: "01/06/20",
        hour: "08:35:00",
        rows: ["Declarado: € 100.000,00", "Diferencia: € 470,00"],
      },
      {
        label: "Delegación: Bahía Blanca",
        date: "01/06/20",
        hour: "08:35:00",
        rows: ["Declarado: € 100.000,00", "Diferencia: € 470,00"],
      },
      {
        label: "Delegación: Bahía Blanca",
        date: "01/06/20",
        hour: "08:35:00",
        rows: ["Declarado: € 100.000,00", "Diferencia: € 470,00"],
      },
    ],
  })
  data:
    | [
        {
          label: string;
          date: string;
          hour: string;
          rows: string[];
        }
      ]
    | undefined;
}
</script>

<style lang="scss" scoped>
.border {
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
  width: 357px;
  margin-bottom: 2rem;
}
.header {
  margin: 0 55px 25px 0;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #9b9b9b;
  padding-top: 0.5rem;
}
.capitalize-all {
  text-transform: uppercase;
}

.date {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: bold;
  color: var(--amarillo-prosegur);
  padding-left: 0.5rem;
}

.data-header {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #9b9b9b;
}

.data-body {
  width: 130px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #4a4a4a;
}

.row-data {
  position: relative;
  padding-bottom: 1rem;
}

.date-container {
  padding-left: 2rem;
  z-index: 1;
  margin-right: 1.5rem;
}

.horizontal-line {
  border-left: solid 2px #e8e8e8;
  height: 100%;
  margin-left: 6px;
  margin-top: -10px;
  position: absolute;
  z-index: 0;
}

.data-container {
  padding-bottom: 1rem;
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 250px;
}
.data-container::-webkit-scrollbar {
  width: 10px;
}

.hour {
  width: 54px;
  font-size: 12px;
  padding-left: 0.5rem;
  color: #979797;
}
.icon {
  width: 14px;
  color: var(--amarillo-prosegur);
  z-index: 2;
}

.icon-white {
  width: 11px;
  color: white;
  z-index: 3;
  position: absolute;
  padding-left: 3px;
}
</style>
